export default __webpack_public_path__ + "static/media/shopifyNativeConcent7.576bf237.svg";